import { Component, Input, OnInit } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { PopoverController, IonicModule, ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { GroupsStore } from 'src/app/core/stores/groups.store';
import { RLSTypesEnum } from 'src/app/core/enums/rls-types.enum';
import { ResourcesEndpointEnum } from 'src/app/core/enums/resources-endpoint.enum';
import { GroupInterface } from 'src/app/core/interfaces/group.interface';
import { ResourceService } from 'src/app/core/services/resource.service';
import { UserInterface } from 'src/app/core/interfaces/user.interface';
import { GetUserEmailModalComponent } from '../../modals/get-user-email-modal/get-user-email-modal.component';

@Component({
  selector: 'set-rls-for-test-report-popover',
  templateUrl: './set-rls-for-test-report-popover.component.html',
  styleUrls: ['./set-rls-for-test-report-popover.component.scss'],
  standalone: true,
  imports: [IonicModule,
    ReactiveFormsModule,
    NgIf,
    NgFor,
    TranslateModule]
})
export class SetRLSForTestPopoverComponent implements OnInit {
  @Input() RLSType?: RLSTypesEnum;
  RLSform!: FormGroup;
  RLSFormProcessing = false;
  RLSFormSubmitted = false;
  groups: GroupInterface[];
  emailConfigured: boolean = false;
  groupsConfigured: boolean = false;
  domainConfigured: boolean = false;
  ssasEIdUsernameConfigured: boolean = false;

  constructor(private popoverCtrl: PopoverController,
    private groupsStore: GroupsStore,
    private resourceService: ResourceService,
    private translateService: TranslateService,
    private toastrService: ToastrService,
    private modalController: ModalController,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.RLSform = this.formBuilder.group({
      RLSPopoverInput: ['', [Validators.required]],
    });
    if(this.RLSType && this.RLSType == RLSTypesEnum.GroupName) {
      this.groupsStore.groups$.subscribe({
        next: (groups: GroupInterface[]|null) => {
          if(groups !== null) {
            this.groups = groups.filter((group) => group.Active === true) as GroupInterface[];
            this.groupsConfigured = true;
          }
          else{
            this.groupsConfigured = false;
            this.emailConfigured = true;
          }
        },
        error: (err) => {
          throwError(() => err);
        }
      });
    }
    else if(this.RLSType && this.RLSType == RLSTypesEnum.FullEmail) {
      this.emailConfigured = true;
    }
    else if(this.RLSType && this.RLSType == RLSTypesEnum.EmailDomain) {
      this.domainConfigured = true;
    }
    else if(this.RLSType && this.RLSType == RLSTypesEnum.ssasEIdUsername) {
      this.ssasEIdUsernameConfigured = true;
    }
  }

  async openEmailPicker() {
    this.resourceService.getCollection<UserInterface>(ResourcesEndpointEnum.GET_USERS).subscribe({
      next: async (users: UserInterface[]) => {
        const modal = await this.modalController.create({
          component: GetUserEmailModalComponent,
          cssClass: 'custom-modal',
          componentProps: {
            users
          }
        });
        modal.present();
        modal.onDidDismiss().then((event) => {
          if (event.data) {
            this.RLSform.patchValue({ RLSPopoverInput: event.data });
          }
        });
      },
      error: (err) => {
        this.translateService.get('Error loading the users').subscribe(t => {
          this.toastrService.error(t);
        })
      },
    });
  }

  dismissPopover() {
    this.RLSFormSubmitted = true;
    if(this.RLSform.invalid) {
    }
    else{
      return this.popoverCtrl.dismiss(this.RLSform.value);
    }
  }
}
